import React from "react"

import "./static/styles/index.css"
import { ToastProvider } from "react-toast-notifications"
import { Providers } from "./src/providers/providers"
import { Layout } from "./src/components/Layout/Layout"
import { AnalyticsProvider } from "./src/analytics/provider"

import config from "./config.default.js"

export const wrapRootElement = ({ element }) => <Providers>{element}</Providers>

export const wrapPageElement = ({ element, props }) => (
  <ToastProvider placement="bottom-center">
    <AnalyticsProvider pageProps={props} settings={config.services}>
      <Layout {...props} settings={config.settings}>
        {element}
      </Layout>
    </AnalyticsProvider>
  </ToastProvider>
)

export const onRouteUpdate = props => {
  const { location, prevLocation } = props
  if (
    location?.pathname !== prevLocation?.pathname &&
    /collection|search/.test(location?.pathname) &&
    /collection|search/.test(prevLocation?.pathname)
  )
    window.dispatchEvent(new Event("refreshSearch"))
}
